import css from "standard/css";

const style = css`
  .educash {
    display: flex;
    align-items: center;
    gap: var(--spacing_inset-nano);
  }

  .educash__span {
    font-family: var(--font-family-highlight);
    font-size: var(--font-size-xs);
    font-weight: var(--font-weight-medium);
    color: var(--color-ocean);
  }
`;

export default style;
